import React, { createContext, useContext } from "react";

export const XYFlowContext = createContext<any>(null);

export const useXYFlow = () => {
  const context = useContext(XYFlowContext);
  if (!context) {
    throw new Error("useXYFlow must be used within an XYFlowProvider");
  }

  return context;
};
